/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: X_QPCLZdjX0b
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PageLayout from "../../PageLayout"; // plasmic-import: CF9w0NRrnxvp/component
import SectionHero from "../../SectionHero"; // plasmic-import: LAgK4hEGm2TV/component
import TopNav from "../../TopNav"; // plasmic-import: MzgISFkf8fEm/component
import ButtonPage from "../../ButtonPage"; // plasmic-import: voJV0X1zqcH0/component
import HeroUnerline from "../../HeroUnerline"; // plasmic-import: pfVxagK4NBto/component
import SectionFooter from "../../SectionFooter"; // plasmic-import: NAltgsviawN1/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicMission.module.css"; // plasmic-import: X_QPCLZdjX0b/css

createPlasmicElementProxy;

export const PlasmicMission__VariantProps = new Array();

export const PlasmicMission__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicMission__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"pageHome"}
          data-plasmic-override={overrides.pageHome}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames,
            sty.pageHome
          )}
        >
          <PageLayout
            data-plasmic-name={"pageLayout"}
            data-plasmic-override={overrides.pageLayout}
            className={classNames("__wab_instance", sty.pageLayout)}
            content={
              <React.Fragment>
                <SectionHero
                  data-plasmic-name={"sectionHero"}
                  data-plasmic-override={overrides.sectionHero}
                  className={classNames("__wab_instance", sty.sectionHero)}
                  colWidth={"medium"}
                  navbar={
                    <TopNav
                      data-plasmic-name={"topNav"}
                      data-plasmic-override={overrides.topNav}
                      className={classNames("__wab_instance", sty.topNav)}
                      pageButtons={
                        <React.Fragment>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___4MWFv
                            )}
                          >
                            {"["}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage___7GoPc
                            )}
                            content={"overview"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerOverview"] = true
                                ? (() => {
                                    const actionArgs = { destination: `/` };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerOverview"] != null &&
                                typeof $steps["goToPartnerOverview"] ===
                                  "object" &&
                                typeof $steps["goToPartnerOverview"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerOverview"] =
                                  await $steps["goToPartnerOverview"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__zxUv5
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage___9Jm4X
                            )}
                            content={"mission"}
                            isSelected={true}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerMission"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/mission`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerMission"] != null &&
                                typeof $steps["goToPartnerMission"] ===
                                  "object" &&
                                typeof $steps["goToPartnerMission"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerMission"] =
                                  await $steps["goToPartnerMission"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__jcgwf
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__bGXch
                            )}
                            content={"the independent"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerOpenCall"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/the-independent`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerOpenCall"] != null &&
                                typeof $steps["goToPartnerOpenCall"] ===
                                  "object" &&
                                typeof $steps["goToPartnerOpenCall"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerOpenCall"] =
                                  await $steps["goToPartnerOpenCall"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__hCND
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__fVa5Q
                            )}
                            content={"early bird"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToEarlyBird"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/early-bird`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToEarlyBird"] != null &&
                                typeof $steps["goToEarlyBird"] === "object" &&
                                typeof $steps["goToEarlyBird"].then ===
                                  "function"
                              ) {
                                $steps["goToEarlyBird"] =
                                  await $steps["goToEarlyBird"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__udkLq
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__wxxV
                            )}
                            content={"contact"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToHttpsO21PComSupport"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: "https://o21p.com/support"
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToHttpsO21PComSupport"] != null &&
                                typeof $steps["goToHttpsO21PComSupport"] ===
                                  "object" &&
                                typeof $steps["goToHttpsO21PComSupport"]
                                  .then === "function"
                              ) {
                                $steps["goToHttpsO21PComSupport"] =
                                  await $steps["goToHttpsO21PComSupport"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__pnPIq
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__pFvE
                            )}
                            content={"join the community"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToHttpsO21PComPartnersCommunity"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination:
                                        "https://o21p.com/partners-community"
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToHttpsO21PComPartnersCommunity"] !=
                                  null &&
                                typeof $steps[
                                  "goToHttpsO21PComPartnersCommunity"
                                ] === "object" &&
                                typeof $steps[
                                  "goToHttpsO21PComPartnersCommunity"
                                ].then === "function"
                              ) {
                                $steps["goToHttpsO21PComPartnersCommunity"] =
                                  await $steps[
                                    "goToHttpsO21PComPartnersCommunity"
                                  ];
                              }
                            }}
                            textColor={"brand"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__uuN1D
                            )}
                          >
                            {"]"}
                          </div>
                        </React.Fragment>
                      }
                    />
                  }
                  sectionId={"top"}
                  showTagline={true}
                  slot={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__iufP
                      )}
                    >
                      {
                        "Everything we do is driven by our belief that autonomy is the foundation of meaningful work."
                      }
                    </div>
                  }
                >
                  <h1
                    data-plasmic-name={"h1"}
                    data-plasmic-override={overrides.h1}
                    className={classNames(
                      projectcss.all,
                      projectcss.h1,
                      projectcss.__wab_text,
                      sty.h1
                    )}
                  >
                    {"o21p mission."}
                  </h1>
                </SectionHero>
                <section
                  data-plasmic-name={"s1"}
                  data-plasmic-override={overrides.s1}
                  className={classNames(projectcss.all, sty.s1)}
                >
                  <div
                    data-plasmic-name={"container"}
                    data-plasmic-override={overrides.container}
                    className={classNames(projectcss.all, sty.container)}
                  >
                    <HeroUnerline
                      data-plasmic-name={"heroUnerline"}
                      data-plasmic-override={overrides.heroUnerline}
                      className={classNames("__wab_instance", sty.heroUnerline)}
                    />

                    <div
                      data-plasmic-name={"wrapperDiv"}
                      data-plasmic-override={overrides.wrapperDiv}
                      className={classNames(projectcss.all, sty.wrapperDiv)}
                      onScroll={async event => {
                        const $steps = {};
                      }}
                    >
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__ny33
                        )}
                      >
                        {
                          "Most independent clinicians try to run and grow their practice through trial and error, by hoping, adapting, and figuring it out as they go."
                        }
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__bZxg1
                        )}
                      >
                        {
                          "It\u2019s demanding, extremely risky, full of uncertainty and constant pressure."
                        }
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__vXbnx
                        )}
                      >
                        {"We call this necessary."}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__qwQzr
                        )}
                      >
                        {"paragraph"}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p___5L5Hq
                        )}
                      >
                        {"paragraph"}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__bxBw
                        )}
                      >
                        {"paragraph"}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__bbrPe
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>
                            {"Our mission is simple: "}
                          </React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ color: "#0088CC", fontWeight: 600 }}
                          >
                            {
                              "empower the independent to navigate today\u2019s complexity without sacrificing autonomy."
                            }
                          </span>
                        </React.Fragment>
                      </p>
                    </div>
                  </div>
                </section>
                <SectionFooter
                  data-plasmic-name={"sectionFooter"}
                  data-plasmic-override={overrides.sectionFooter}
                  className={classNames("__wab_instance", sty.sectionFooter)}
                  layout={"withOffset"}
                  sectionId={"footer"}
                />
              </React.Fragment>
            }
            layoutSections={"withNav"}
          />

          {(hasVariant(globalVariants, "screen", "tablet") ? true : false) ? (
            <div
              data-plasmic-name={"noBudgetSmallScreens"}
              data-plasmic-override={overrides.noBudgetSmallScreens}
              className={classNames(projectcss.all, sty.noBudgetSmallScreens)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__eiDjm
                )}
              >
                {"o21p"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__vhHb0
                )}
              >
                {
                  "our massive development budget is dedicated to designing and building the platform for larger screens."
                }
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__gcpDc
                )}
              >
                {"\u2013 at least 900px wide \u2013"}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageHome: [
    "pageHome",
    "pageLayout",
    "sectionHero",
    "topNav",
    "h1",
    "s1",
    "container",
    "heroUnerline",
    "wrapperDiv",
    "sectionFooter",
    "noBudgetSmallScreens"
  ],

  pageLayout: [
    "pageLayout",
    "sectionHero",
    "topNav",
    "h1",
    "s1",
    "container",
    "heroUnerline",
    "wrapperDiv",
    "sectionFooter"
  ],

  sectionHero: ["sectionHero", "topNav", "h1"],
  topNav: ["topNav"],
  h1: ["h1"],
  s1: ["s1", "container", "heroUnerline", "wrapperDiv"],
  container: ["container", "heroUnerline", "wrapperDiv"],
  heroUnerline: ["heroUnerline"],
  wrapperDiv: ["wrapperDiv"],
  sectionFooter: ["sectionFooter"],
  noBudgetSmallScreens: ["noBudgetSmallScreens"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMission__ArgProps,
          internalVariantPropNames: PlasmicMission__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMission__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageHome") {
    func.displayName = "PlasmicMission";
  } else {
    func.displayName = `PlasmicMission.${nodeName}`;
  }
  return func;
}

export const PlasmicMission = Object.assign(
  // Top-level PlasmicMission renders the root element
  makeNodeComponent("pageHome"),
  {
    // Helper components rendering sub-elements
    pageLayout: makeNodeComponent("pageLayout"),
    sectionHero: makeNodeComponent("sectionHero"),
    topNav: makeNodeComponent("topNav"),
    h1: makeNodeComponent("h1"),
    s1: makeNodeComponent("s1"),
    container: makeNodeComponent("container"),
    heroUnerline: makeNodeComponent("heroUnerline"),
    wrapperDiv: makeNodeComponent("wrapperDiv"),
    sectionFooter: makeNodeComponent("sectionFooter"),
    noBudgetSmallScreens: makeNodeComponent("noBudgetSmallScreens"),
    // Metadata about props expected for PlasmicMission
    internalVariantProps: PlasmicMission__VariantProps,
    internalArgProps: PlasmicMission__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "o21p mission.",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicMission;
/* prettier-ignore-end */
